
import UnrankedPortfolioConfirmationDrawer from './UnrankedPortfolioConfirmationDrawer.vue';
import UnrankedPortfolioConfirmationModal from './UnrankedPortfolioConfirmationModal.vue';
import { isMobileResponsive } from '@/utils/mixins';
import { getWindowInstance } from '@/plugins/windowInstance';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'UnrankedPortfolioConfirmationComponent',
  components: {
    UnrankedPortfolioConfirmationDrawer,
    UnrankedPortfolioConfirmationModal,
  },
  mixins: [isMobileResponsive],
  computed: {
    isMobileResponsive() {
      // @ts-ignore TODO fix typescript not recognizing this
      return getWindowInstance(this).isMobileResponsive();
    },
    ...mapGetters('modals', ['unrankedPortfolioConfirmationComponent']),
  },
  methods: {
    ...mapActions('modals', ['toggleUnrankedPortfolioConfirmationComponent']),
    handleConfirm() {
      if (this.unrankedPortfolioConfirmationComponent.itemPayload) {
        this.$emit(
          'addItem',
          this.unrankedPortfolioConfirmationComponent.itemPayload
        );
        this.shouldResetFlag = false;
        this.toggleUnrankedPortfolioConfirmationComponent({
          show: false,
        });
      }

      if (
        this.unrankedPortfolioConfirmationComponent.operationPayload &&
        this.unrankedPortfolioConfirmationComponent.itemId
      ) {
        if (
          this.unrankedPortfolioConfirmationComponent.operationPayload
            .operationType == 'Buy'
        ) {
          this.$emit('addOperation', {
            itemId: this.unrankedPortfolioConfirmationComponent.itemId,
            operationPayload:
              this.unrankedPortfolioConfirmationComponent.operationPayload,
            validateAllocation: true,
            transactionModalShouldStayOpen:
              this.unrankedPortfolioConfirmationComponent
                .transactionModalShouldStayOpen,
          });
        } else {
          this.$emit('addOperation', {
            itemId: this.unrankedPortfolioConfirmationComponent.itemId,
            operationPayload:
              this.unrankedPortfolioConfirmationComponent.operationPayload,
            validateAllocation: false,
            transactionModalShouldStayOpen:
              this.unrankedPortfolioConfirmationComponent
                .transactionModalShouldStayOpen,
          });
        }
        this.shouldResetFlag = false;
        this.toggleUnrankedPortfolioConfirmationComponent({
          show: false,
        });
      }
    },
    handleClose() {
      this.toggleUnrankedPortfolioConfirmationComponent({
        show: false,
      });
    },
  },
};
